import React from "react";
import {
  IconTrash,
  IconPencil,
} from "@tabler/icons";
import _ from "lodash";
import { TextInput } from "@mantine/core";
import CreatableTypeSelect from "./creatableTypeSelect";
import InlineContactList from "./inlineContactList";
import { DATA_EMAIL_TYPE } from "../data/options";
import { useCellRender } from "../hooks/useCellRender";

const EMPTY_EMAIL_DRAFT = {
  type: "personal",
  value: "",
  tags: [],
  isDefault: false,
};

const TYPE_COLUMN_WIDTH = 160;

const EmailList = ({ form: mainForm, name, readOnly, ...props }) => {
  const emails = _.get(mainForm.values, name) ?? [];
  const [cellRender] = useCellRender();

  const columns = [
    {
      field: "type",
      headerName: "Type",
      width: TYPE_COLUMN_WIDTH,
      cellRender: (col, data) => cellRender.ContactType(data.type),
    },
    {
      field: "value",
      headerName: "Email",
    },
    {
      field: "_actions",
      width: 72,
      isAction: true,
      actions: [
        {
          name: "edit",
          label: "Edit",
          icon: IconPencil,
          props: {},
        },
        {
          name: "delete",
          label: "Delete",
          icon: IconTrash,
          props: {},
        },
      ],
    },
  ];

  const validate = (values) => {
    const errors = {};
    if (!values.value?.trim()) {
      errors.value = "Required";
    } else if (!/^\S+@\S+$/.test(values.value.trim())) {
      errors.value = "Invalid email";
    }
    return errors;
  };

  const normalizeEntry = (values, existingRow) => ({
    type: values.type?.trim() || "personal",
    value: values.value?.trim() ?? "",
    tags: existingRow?.tags ?? [],
    isDefault: Boolean(existingRow?.isDefault),
  });

  const onChange = (values) => {
    mainForm.updateAndSave({ [name]: values });
  };

  const renderFields = (form) => (
    <>
      <td
        style={{
          verticalAlign: "top",
          width: TYPE_COLUMN_WIDTH,
          minWidth: TYPE_COLUMN_WIDTH,
        }}
      >
          <CreatableTypeSelect
            form={form}
            name="type"
            items={DATA_EMAIL_TYPE}
            required
            size="xs"
          />
        </td>
        <td style={{ verticalAlign: "top" }}>
          <TextInput
            required
            size="xs"
            placeholder="john@example.com"
            {...form.getInputProps("value")}
          />
        </td>
    </>
  );

  return (
    <InlineContactList
      rows={emails}
      readOnly={readOnly}
      onChange={onChange}
      columns={columns}
      emptyDraft={EMPTY_EMAIL_DRAFT}
      validate={validate}
      normalizeEntry={normalizeEntry}
      renderFields={renderFields}
      {...props}
    />
  );
};

export default EmailList;
